import 'css-chunk:src/components/form-fields/countdown-component/countdown-component.module.scss';export default {};